import { yupResolver } from '@hookform/resolvers/yup'
import * as ReactHookForm from 'react-hook-form'

export const useForm = <T extends ReactHookForm.FieldValues>(schema, formProps?: ReactHookForm.UseFormProps<T>) => {
  return ReactHookForm.useForm<T>({ ...formProps, resolver: yupResolver(schema) as any })
}
